import { useState } from 'react'

export function usePaginationCursor() {
  const [cursor, setCursor] = useState<string | null>(null)
  const [cursorStack, setCursorStack] = useState<string[]>([])

  const goNext = (nextCursor: string | null) => {
    if (!nextCursor) return
    // on push le cursor actuel (même null => page 1)
    setCursorStack((prev) => [...prev, cursor ?? ''])
    setCursor(nextCursor)
  }

  const goPrev = () => {
    setCursorStack((prev) => {
      if (prev.length === 0) return prev
      const newStack = prev.slice(0, -1)
      const last = prev[prev.length - 1] // '' représente null/page1
      setCursor(last === '' ? null : last)
      return newStack
    })
  }

  const reset = () => {
    setCursor(null)
    setCursorStack([])
  }

  return { cursor, cursorStack, goNext, goPrev, reset }
}
